import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const StyledCardsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'grid',
  justifyContent: 'center',
  gap: theme.spacing(3),
  alignItems: 'start',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    maxWidth: '1200px',
    margin: '0 auto',
    
    // When there are 4 items, switch to 2x2 grid
    '&:has(:nth-child(4))': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      maxWidth: '1000px',
    },
  },
  
  [theme.breakpoints.between('sm', 'md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(3),
  },
  
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(5),
    gridTemplateColumns: '1fr',
    gap: theme.spacing(4),
  },
}));
